import styled from 'styled-components'

export const GoBackButton = styled.button`
  border-radius: 4px;
  border: 1px solid rgba(32, 32, 32, 0.2);
  padding: 0 16px;
  background: #fff;
  height: 40px;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  color: #202020;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center; 
  
  svg {
    margin-right: 8px;
  }
`

export const EditProfileButton = styled.button`
  background: #0aa1f4;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.05);
  border-radius: 4px;
  height: 40px;
  width: 100%;
  color: #fff;
  border: none;
  padding:0 16px;
  cursor: pointer;  
`

export const TopBarButtonWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 24px;
  font-weight: 500;

  > button {
    height: 40px;
    margin-top: 0;
    display: flex;
    align-items: center;

    > svg {
      margin-right: 8px;
    }
  }
`
